<template>
    <div>
    <b-card no-body>
        <b-card-header>
            <span class="h5"> Centros de Custos </span>
        </b-card-header>
        <b-card-body>
                <app-tabela
                    idTabela="tblComprometimentos"
                    :itens="rateiosComprometimentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false">
                <template slot="botoes" slot-scope="data"> 
                    <b-button-group class="float-right">
                        <btn-inserir-projeto-acao
                            v-if="$temAcessoView('CONV-PRJ-01')"
                            :convenio="convenio"
                            :comprometimento="data"
                            @atualizarListaComprometimentos="atualizarListaComprometimentos()">
                        </btn-inserir-projeto-acao>
                    </b-button-group>
                </template>

                <template slot="acoes" slot-scope="data">
                    <span class="text-primary float-left">
                        <btn-atualizar-projeto-acao
                            v-if="$temAcessoView('CONV-PRJ-01')"
                            :convenio="convenio"
                            :comprometimento="data"
                            @atualizarListaComprometimentos="atualizarListaComprometimentos()">
                        </btn-atualizar-projeto-acao>
                    </span>
                    <span class="text-primary float-left">
                        <btn-excluir-projeto-acao
                            v-if="$temAcessoView('CONV-PRJ-01')"
                            :convenio="convenio"
                            :comprometimento="data"
                            @atualizarListaComprometimentos="atualizarListaComprometimentos()">
                        </btn-excluir-projeto-acao>
                    </span>
                    <!-- <span
                        class="text-success float-left mr-1"
                        v-if="$temAcessoView('CONV-PRJ-03')">
                        <i
                            class="fa fa-money fa-lg icon-button"
                            title="Comprometer Valor no RM"
                            @click.stop="comprometerRM(data.idRateioComprometimento)"
                        ></i>
                    </span> -->
                </template>

                <template slot="nuValorRateio" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorRateio | currency }}
                    </p>
                </template>
                </app-tabela>
        </b-card-body>
    </b-card>
    </div>
</template>

<script>
    import BtnInserirProjetoAcao from "../cadastro/projetoAcao/BtnInserirProjetoAcao.vue"
    import BtnAtualizarProjetoAcao from "../cadastro/projetoAcao/BtnAtualizarProjetoAcao.vue"
    import BtnExcluirProjetoAcao from "../cadastro/projetoAcao/BtnExcluirProjetoAcao.vue"
    import ConveniosServicos from '../ConveniosServicos'

    export default {
        components: {
            BtnInserirProjetoAcao,
            BtnAtualizarProjetoAcao,
            BtnExcluirProjetoAcao
        },

        props: {
            convenio: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                erros: [],
                rateiosComprometimentos: [],
                itensPorPagina: 5,
                campos: [
                    {
                        key: 'nomeCCusto',
                        label: 'Centro de Custo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'cronogramaDesembolso.nuParcela',
                        label: 'Parcela',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'nuValorRateio',
                        label: 'Valor Rateio',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acoes',
                        label: ''
                    }
                ],
            }
        },

        methods:{
            atualizarListaComprometimentos(){
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterPorId(this.convenio.idConvenio)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.rateiosComprometimentos = response.data.rateiosComprometimentos
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            // comprometerRM(id){

            // }
        },

        watch:{
            convenio(){
                if(this.convenio){
                    this.rateiosComprometimentos = this.convenio.rateiosComprometimentos
                    console.log(this.rateiosComprometimentos)
                }
            }
        },
    }
</script>